import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as myGlobal from '../../../global';
import { CookieService } from 'ngx-cookie-service';

@Injectable( {
    providedIn: 'root'
} )
export class DashboardService {

    constructor( private http: HttpClient, private cookieService: CookieService ) {
    }

    getUserInfo( userid, assessmentContextId ) {
        return this.http.get( myGlobal.Questionnaires + '/' + 'userInfo' + '/' + userid + '?assessment_context_id=' + assessmentContextId );
    }

    createPropertyInfo( newProperty ) {
        return this.http.post( myGlobal.PROPERTY_MANAGEMENT + '/' + 'properties', newProperty );
    }

    getAssessmentSubtypeName( subtypeId ) {
        return this.http.get( myGlobal.ASSESSMENT_MANAGEMENT + '/' + 'assessment_subtypes' + '/' + subtypeId );
    }

    getPropertyInfo( propertyId, userid ) {
        return this.http.get( myGlobal.PROPERTY_MANAGEMENT + '/' + 'properties' + '/' + propertyId + '/' + userid );
    }

    getlastfinalScore( userId ) {
        return this.http.get( myGlobal.Questionnaires + '/' + 'viewResultSummery?user_id=' + userId );
    }

}
